"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOGINED_MODE = exports.NO_INVITER = exports.HAS_INVITER = exports.CHILD = exports.ROOT = void 0;
exports.ROOT = 'inviter-container-1';
exports.CHILD = 'inviter-container-1/item';
exports.HAS_INVITER = 1; // 有邀请人
exports.NO_INVITER = 0; // 无邀请人
exports.LOGINED_MODE = {
    BOTH: 0,
    NO: 1 // 登录态显示无邀请人界面
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjb25zdGFudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLElBQUksR0FBRyxxQkFBcUIsQ0FBQztBQUM3QixRQUFBLEtBQUssR0FBRywwQkFBMEIsQ0FBQztBQUNuQyxRQUFBLFdBQVcsR0FBRyxDQUFDLENBQUMsQ0FBQyxPQUFPO0FBQ3hCLFFBQUEsVUFBVSxHQUFHLENBQUMsQ0FBQyxDQUFDLE9BQU87QUFDdkIsUUFBQSxZQUFZLEdBQUc7SUFDeEIsSUFBSSxFQUFFLENBQUM7SUFDUCxFQUFFLEVBQUUsQ0FBQyxDQUFDLGNBQWM7Q0FDdkIsQ0FBQyJ9